import { render, staticRenderFns } from "./OpportunityPanelHeader.vue?vue&type=template&id=0afc7661&scoped=true&"
import script from "./OpportunityPanelHeader.vue?vue&type=script&lang=js&"
export * from "./OpportunityPanelHeader.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityPanelHeader.vue?vue&type=style&index=0&id=0afc7661&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afc7661",
  null
  
)

export default component.exports